module.exports = __webpack_public_path__ + "img/arrow-right.0e2ba65c.svg";